import { ContentBlocks } from '../components/ContentBlocks'
import { SiteContentLayout } from '../components/SiteContentLayout'
import type { LegalPageProps } from '../constants/content-pages'

export function LegalPage({ content }: LegalPageProps) {
  return (
    <SiteContentLayout title={content.title} lead={content.lead}>
      <p className="content-page__meta">Effective date: {content.effectiveDate}</p>
      <div className="content-page__prose">
        {content.sections.map((section) => (
          <section key={section.title} className="content-page__section">
            <h2>{section.title}</h2>
            <ContentBlocks blocks={section.blocks} />
          </section>
        ))}
        <p className="content-page__closing">{content.closing}</p>
      </div>
    </SiteContentLayout>
  )
}
